export default __webpack_public_path__ + "static/media/transfer-figure.8134afd3.png";